/* Spanish catalog mirroring locale-sales-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'adv.sales.productsShowMore': 'Mostrar más',
  'adv.sales.productsNote': 'El importe bajo «Mayores ingresos» corresponde a las ventas facturadas por producto en el año seleccionado. Crecimiento y descenso indican la variación porcentual de los ingresos del mismo producto respecto al año anterior. Los productos sin cifras comparables del año anterior no aparecen en crecimiento ni descenso.',
  'adv.sales.productsPage': 'Página {page} de {pages}',
  'adv.sales.productsPrevious': 'Página anterior de {label}',
  'adv.sales.productsNext': 'Página siguiente de {label}',
  'adv.sales.scn.adjust.priceUp': 'Subida de precios',
  'adv.sales.scn.adjust.volumeDown': 'Caída del volumen de ventas',
  'sale.doc.invoice': 'Nueva factura',
  'sale.doc.quote': 'Nuevo presupuesto',
  'sale.doc.orderConfirmation': 'Nueva confirmación de pedido',
  'sale.doc.creditNote': 'Nueva nota de crédito',
  'sale.doc.other': 'Otra venta',
  'sale.howToCreate': '¿Cómo quieres crear {document}?',
  'sale.docIndefinite.invoice': 'una factura',
  'sale.docIndefinite.quote': 'un presupuesto',
  'sale.docIndefinite.orderConfirmation': 'una confirmación de pedido',
  'sale.docIndefinite.creditNote': 'una nota de crédito',
  'sale.docIndefinite.other': 'otra venta',
  'sale.credit.title': 'Nota de crédito',
  'sale.credit.help': 'Una nota de crédito anula una venta. Los importes se introducen en positivo, igual que en una factura: Plumme invierte el signo al contabilizar, de modo que los ingresos por ventas y el IVA repercutido se reducen y se abona la cuenta a cobrar.',
  'sale.credit.reason': 'Motivo de la nota de crédito',
  'sale.credit.reasonHint': 'Obligatorio. El registro debe mostrar lo que realmente ocurrió, no solo el importe.',
  'sale.credit.reasonPh': 'Devolución de mercancía, rebaja de precio, factura incorrecta ...',
  'sale.credit.link': 'Vincular a una factura',
  'sale.credit.linkHint': 'Opcional. Si la vinculas, el número de factura se añade automáticamente y la nota de crédito se compensa con el importe pendiente de esa factura.',
  'sale.credit.linkNone': 'Sin vínculo – crédito abierto del cliente',
  'sale.credit.linkSearchPh': 'Buscar por número de factura, cliente o importe ...',
  'sale.credit.linkNoMatches': 'Ninguna factura coincide con la búsqueda',
  'sale.credit.linkShowMore': 'Mostrar más facturas',
  'sale.credit.invoiceOption': 'Factura {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Seleccionada desde la factura',
  'sale.credit.noNumber': 'Sin número',
  'sale.credit.reference': 'Se aplica a (venta original)',
  'sale.credit.referenceHint': 'Obligatorio sin vínculo a una factura. Indica el número de factura, el contrato, el periodo o el sistema en el que estaba la venta.',
  'sale.credit.referencePh': 'P. ej. factura 1042 o «contrato 2025-04»',
  'sale.credit.linkedTo': 'Abona la factura {document}',
  'sale.credit.offsetBadge': 'Compensada automáticamente',
  'sale.credit.freeHint': 'Sin vínculo, el importe queda como crédito del cliente. Puedes compensarlo con una factura o reembolsarlo desde la lista de facturas.',
  'sale.credit.date': 'Fecha de la nota de crédito',
  'sale.credit.numberLabel': 'N.º de nota de crédito:',
  'sale.credit.amount': 'Importe del crédito',
  'sale.credit.previewNote': 'El importe se ha abonado. Se compensa con las facturas pendientes o se reembolsa.',
  'sale.credit.previewReason': 'Motivo:',
  'sale.credit.previewReference': 'Se aplica a:',
  'sale.credit.set': 'Indicar detalles',
  'sale.credit.edit': 'Editar',
  'sale.credit.missing': 'Se requieren un motivo y una referencia a la venta original antes de poder crear la nota de crédito.',
  'sale.credit.noReference': 'Sin referencia indicada',
  'sale.credit.freeBadge': 'Crédito abierto del cliente',
  'sale.credit.needReason': 'Indica primero el motivo de la nota de crédito',
  'sale.credit.needReference': 'Vincula una factura o identifica la venta original a la que se aplica esta nota de crédito',
  'sale.credit.needDetails': 'Indica primero un motivo y vincula una factura o identifica la venta original',
  'sale.credit.create': 'Crear nota de crédito',
  'sale.det.period': 'Periodo',
  'sale.det.subscriptionFrom': 'Suscripción desde',
  'sale.det.subscriptionTo': 'Suscripción hasta',
  'sale.det.rentFrom': 'Alquiler desde',
  'sale.det.rentTo': 'Alquiler hasta',
  'sale.lines.descShortPh': 'P. ej. hora de consultoría o suscripción',
  'sale.from': 'Desde',
  'sale.to': 'Hasta',
  'sale.use': 'Usar',
  'sale.swap': 'Intercambiar',
  'sale.show': 'Mostrar',
  'sale.edit': 'Editar',
  'sale.download': 'Descargar',
  'sale.send': 'Enviar',
  'sale.add': 'Añadir',
  'sale.save': 'Guardar',
  'sale.saveChanges': 'Guardar cambios',
  'sale.thisSale': 'esta venta',
  'sale.step.kunde': 'Cliente',
  'sale.step.bilag': 'Justificante',
  'sale.step.detaljer': 'Detalles',
  'sale.step.linjer': 'Líneas',
  'sale.step.forhandsvisning': 'Vista previa',
  'sale.title': 'Venta / Factura / Presupuesto',
  'sale.titleHelp': 'Registra una venta, crea una factura, un presupuesto o una confirmación de pedido',
  'sale.docTypeHelpTitle': 'Tipo de documento',
  'sale.docTypeHelp': 'Elige el tipo de documento de venta que vas a crear. Una factura es una solicitud de pago al cliente. Un presupuesto es una oferta de precio sin compromiso. Una confirmación de pedido confirma un pedido acordado. «Otra venta» sirve para ventas realizadas fuera del sistema, en las que subes un justificante como documentación.',
  'sale.stepsHelpTitle': 'Los pasos de una venta',
  'sale.stepsHelp': 'Una venta tiene cuatro pasos: Cliente, Detalles, Líneas y Vista previa (para «Otra venta»: Justificante, Detalles, Líneas y Vista previa). Pulsa un paso para ir directamente a él. Un paso aparece marcado si falta algo antes de poder crear el documento.',
  'sale.viewHelpTitle': 'Cambiar de vista',
  'sale.viewHelpToOnePage': 'Pasa del flujo paso a paso a una sola página donde se muestran todos los campos a la vez, junto a una vista previa en directo. Más rápido cuando ya conoces el formulario.',
  'sale.viewHelpToSteps': 'Pasa de la página única a un flujo paso a paso más tranquilo, en el que completas una cosa cada vez: cliente, detalles, líneas y vista previa. Ideal si prefieres ir guiado.',
  'sale.toOnePage': 'Cambiar a todo en una página',
  'sale.toSteps': 'Cambiar a paso a paso',
  'sale.stepByStep': 'Paso a paso',
  'sale.previewHelpTitle': 'Vista previa',
  'sale.previewHelp': 'Así verá el cliente el documento final, con remitente, datos del cliente, líneas y total. Se actualiza mientras lo rellenas, para que puedas revisarlo todo antes de crearlo o enviarlo.',
  'sale.previewToggleHelp': 'Muestra u oculta la vista previa en directo junto al formulario. Ocúltala si quieres más espacio para los campos.',
  'sale.previewHide': 'Ocultar vista previa',
  'sale.previewShow': 'Mostrar vista previa',
  'sale.previewHeading': 'Vista previa del documento',
  'sale.backToVouchers': 'Volver a los movimientos',
  'sale.resetTitle': 'Vaciar el formulario y empezar de nuevo',
  'sale.reset': 'Vaciar',
  'sale.resetDone': 'Se ha vaciado el formulario',
  'sale.back': 'Atrás',
  'sale.next': 'Siguiente',
  'sale.draftSaved': 'Borrador guardado',
  'sale.draftSavedHelp': 'El borrador aparece en la lista de facturas tal como está ahora. Si cambias algo, puedes volver a guardar: se actualiza el mismo borrador.',
  'sale.saveDraft': 'Guardar borrador',
  'sale.saveDraftHelpTitle': 'Guardar borrador',
  'sale.saveDraftHelp': 'Guarda la venta como borrador en la lista de facturas sin enviarla ni crearla. Podrás retomarla más tarde donde la dejaste.',
  'sale.saveDraftHelpLong': 'Guarda la venta como borrador en la lista de facturas sin enviarla ni crearla. Puedes salir de la página con tranquilidad y continuar más tarde donde lo dejaste.',
  'sale.saveDraftHelpShort': 'Guarda la venta como borrador en la lista de facturas sin enviarla ni crearla. Puedes salir de la página con tranquilidad y continuar más tarde.',
  'sale.drafts': 'Borradores',
  'sale.draftsTitle': 'Ventas que has empezado pero aún no has creado',
  'sale.noDrafts': 'Sin borradores',
  'sale.searchDrafts': 'Buscar borradores...',
  'sale.deleteDraft': 'Eliminar borrador',
  'sale.deleteDraftTitle': '¿Eliminar borrador?',
  'sale.deleteDraftBody': '¿Seguro que quieres eliminar el borrador de {customer}? Esta acción no se puede deshacer.',
  'sale.det.help': 'Fechas, referencias y un comentario para el documento. La fecha de factura y la fecha de vencimiento determinan cuándo se aplica y vence el cobro. «Nuestra referencia» es la persona que lo gestiona en tu empresa; «Su referencia» es el proyecto o contacto del cliente. En las facturas también puedes activar la recurrencia para que se envíen automáticamente cada periodo.',
  'sale.det.date': 'Fecha',
  'sale.det.due': 'Vencimiento',
  'sale.det.ourRef': 'Nuestra referencia',
  'sale.det.ourRefPh': 'P. ej. la persona que lo gestiona aquí',
  'sale.det.theirRef': 'Su referencia',
  'sale.det.theirRefPh': 'Su referencia / proyecto',
  'sale.det.payTo': 'Pagar a',
  'sale.det.payToHelp': 'La cuenta bancaria a la que el cliente debe pagar la factura. La lista muestra tus cuentas bancarias guardadas: la cuenta de facturación de los ajustes viene preseleccionada y puedes añadir una cuenta nueva aquí mismo.',
  'sale.det.payToDefault': 'Cuenta de facturación',
  'sale.det.payToEmpty': 'No hay ninguna cuenta bancaria guardada',
  'sale.det.payToAdd': '+ Añadir cuenta bancaria ...',
  'sale.det.comment': 'Comentario',
  'sale.det.commentPh': 'Comentario opcional que se muestra en el documento',
  'sale.det.savedComments': 'Comentarios guardados',
  'sale.det.saveComment': 'Guardar comentario',
  'sale.det.useComment': 'Usar comentario',
  'sale.det.noSavedComments': 'Aún no hay comentarios guardados.',
  'sale.det.deliveryFrom': 'Periodo de entrega/prestación - Desde',
  'sale.det.deliveryTo': 'Periodo de entrega/prestación - Hasta',
  'sale.det.repeating': 'Recurrente',
  'sale.det.repeatingHelpTitle': 'Factura recurrente',
  'sale.det.repeatingHelp': 'Actívala para que la factura se envíe automáticamente a intervalos regulares, por ejemplo cada mes en el caso de una suscripción. Tú eliges el intervalo y el vencimiento, y Plumme crea y envía una nueva factura cada periodo sin que tengas que hacer nada.',
  'sale.det.sentEvery': 'Se envía cada',
  'sale.period.week': 'Semana',
  'sale.period.month': 'Mes',
  'sale.period.quarter': 'Trimestre',
  'sale.period.year': 'Anual',
  'sale.det.sameDay': 'El mismo día',
  'sale.lines.help': 'Los bienes y servicios de la venta. Cada línea tiene una cantidad, un precio, un tipo de IVA y, si procede, un descuento, y el total de la línea se calcula automáticamente. Elige un producto guardado o escribe texto libre, y arrastra el control de la izquierda para cambiar el orden.',
  'sale.lines.add': 'Añadir línea',
  'sale.lines.product': 'Producto',
  'sale.lines.productPh': 'Buscar o escribir un producto nuevo...',
  'sale.lines.noProductMatch': 'Ningún producto guardado coincide',
  'sale.lines.editProduct': 'Editar producto',
  'sale.lines.productName': 'Nombre del producto',
  'sale.lines.description': 'Descripción',
  'sale.lines.descriptionPh': 'Descripción opcional del producto/línea',
  'sale.lines.qty': 'Cantidad',
  'sale.lines.vat': 'IVA',
  'sale.lines.discount': 'Descuento',
  'sale.lines.netSum': 'Total de línea sin IVA',
  'sale.lines.toggleVat': 'Cambiar entre sin IVA y con IVA',
  'sale.lines.more': 'Más',
  'sale.lines.less': 'Menos',
  'sale.lines.searchAccount': 'Buscar cuenta...',
  'sale.lines.noAccountMatch': 'Ninguna cuenta coincide con la búsqueda.',
  'sale.lines.pickAccount': 'Elegir cuenta',
  'sale.lines.searchProductPh': 'Buscar por nombre o descripción...',
  'sale.sum.help': 'El total de toda la venta: el importe sin IVA más el IVA es lo que paga el cliente. Las cifras se actualizan automáticamente al cambiar las líneas.',
  'sale.att.title': 'Adjuntos',
  'sale.att.upload': 'Subir adjunto',
  'sale.att.drop': 'Arrastra los archivos aquí',
  'sale.att.dropHint': 'Imágenes o PDF, o pega',
  'sale.att.pickFile': 'Elegir archivo',
  'sale.att.dropToAdd': 'Suelta el adjunto para añadirlo',
  'sale.att.dragTip': 'Consejo: también puedes arrastrar archivos directamente a la página.',
  'sale.att.forgot': '¿Olvidaste un justificante? Suéltalo aquí',
  'sale.att.fromInbox': 'Obtener de la bandeja de entrada',
  'sale.att.uploadInstead': 'Subir un justificante',
  'sale.att.view': 'Ver el justificante',
  'sale.att.openPreview': 'Abrir en vista previa',
  'sale.send.title': 'Envío del documento',
  'sale.send.to': 'Enviar a',
  'sale.send.replyTo': 'Responder a',
  'sale.send.asPdf': 'Enviar como PDF adjunto',
  'sale.send.asLink': 'Enviar como enlace',
  'sale.send.pdfHint': 'El cliente recibe el documento directamente en el correo.',
  'sale.send.linkHint': 'Indica el estado de lectura cuando el cliente abre el documento.',
  'sale.send.how': '¿Cómo debe enviarse el documento?',
  'sale.send.newRecipient': 'Nueva dirección de correo …',
  'sale.send.saveContact': 'Guardar como contacto de {customer}',
  'sale.send.thisCustomer': 'el cliente',
  'sale.send.contactName': 'Nombre',
  'sale.send.contactNamePh': 'Juan Pérez',
  'sale.send.contactRole': 'Cargo',
  'sale.send.contactRolePh': 'Contabilidad',
  'sale.send.contactSaveFailed': 'El documento se envió, pero no se pudo guardar el contacto.',
  'sale.send.emailPh': 'name@example.com',
  'sale.send.viewDocument': 'Ver el documento',
  'sale.preview.sender': 'Remitente:',
  'sale.preview.invoiceNo': 'N.º de factura:',
  'sale.preview.invoiceDate': 'Fecha de factura:',
  'sale.preview.dueDate': 'Fecha de vencimiento:',
  'sale.preview.ourRef': 'Nuestra referencia:',
  'sale.preview.theirRef': 'Su referencia:',
  'sale.preview.comment': 'Comentario:',
  'sale.preview.accountNo': 'N.º de cuenta:',
  'sale.preview.toPay': 'A pagar:',
  'sale.preview.net': 'Neto',
  'sale.preview.vat': 'IVA',
  'sale.preview.paid': 'Pagado',
  'sale.preview.toPayShort': 'A pagar',
  'sale.preview.receipt': 'Recibo',
  'sale.preview.paymentHint': 'Indica el número de factura al realizar el pago',
  'sale.preview.currencyNote': 'Todos los importes están expresados en {currency}',
  'sale.lines.fromDraftDescr': 'Traspasado desde el borrador',
  'sale.att.maxSize': 'Los adjuntos pueden pesar como máximo {max}.',
  'sale.att.addedOne': '1 adjunto añadido',
  'sale.att.addedMany': '{count} adjuntos añadidos',
  'sale.comment.deleted': 'Comentario eliminado',
  'sale.comment.deleteFailed': 'No se pudo eliminar el comentario.',
  'sale.comment.writeFirst': 'Escribe primero un comentario',
  'sale.comment.updated': 'Comentario actualizado',
  'sale.comment.saveFailed': 'No se pudo guardar el comentario.',
  'sale.comment.alreadySaved': 'El comentario ya está guardado',
  'sale.comment.saved': 'Comentario guardado',
  'sale.comment.backendUnavailable': 'Los comentarios no están conectados al backend.',
  'sale.det.offerDate': 'Fecha del presupuesto',
  'sale.det.orderDate': 'Fecha del pedido',
  'sale.det.saleDate': 'Fecha de la venta',
  'sale.det.invoiceDateLabel': 'Fecha de factura',
  'sale.det.validUntil': 'Válido hasta',
  'sale.det.dueDateLabel': 'Fecha de vencimiento',
  'sale.textLine.titleUpdate': 'Actualizar línea de texto',
  'sale.textLine.titleNewHeading': 'Nuevo encabezado',
  'sale.textLine.titleNewText': 'Nueva línea de texto',
  'sale.textLine.update': 'Actualizar',
  'sale.textLine.typeLabel': 'Tipo',
  'sale.textLine.typeText': 'Línea de texto',
  'sale.textLine.typeHeading': 'Encabezado',
  'sale.textLine.nameLabel': 'Nombre',
  'sale.textLine.namePhHeading': 'P. ej. Trabajos',
  'sale.textLine.namePhText': 'P. ej. Producto X',
  'sale.textLine.textLabel': 'Texto',
  'sale.textLine.textPh': 'Texto opcional que se muestra bajo la línea',
  'sale.textLine.styleFor': 'Estilo para {target}',
  'sale.textLine.boldShort': 'N',
  'sale.textLine.italicShort': 'C',
  'sale.textLine.useDivider': 'Usar línea separadora',
  'sale.textLine.dividerHint': 'Muestra una línea bajo el texto en el documento.',
  'sale.textLine.searchPhHeading': 'Buscar o escribir un encabezado...',
  'sale.textLine.searchPhText': 'Buscar o escribir una línea de texto...',
  'sale.textLine.noMatch': 'Ninguna línea de texto guardada coincide',
  'sale.textLine.addAsHeading': 'Añadir «{value}» como nuevo encabezado',
  'sale.textLine.addAsText': 'Añadir «{value}» como nueva línea de texto',
  'sale.textLine.headingSaved': 'Encabezado guardado',
  'sale.textLine.textSaved': 'Línea de texto guardada',
  'sale.textLine.headingAdded': 'Encabezado añadido',
  'sale.textLine.textAdded': 'Línea de texto añadida',
  'sale.textLine.saveFailed': 'No se pudo guardar la línea de texto.',
  'sale.det.durationMonth1': '1 mes',
  'sale.det.durationMonth3': '3 meses',
  'sale.det.durationMonth6': '6 meses',
  'sale.det.durationMonth12': '12 meses',
  'sale.lines.typeProduct': 'Línea de producto',
  'sale.lines.typeSpacer': 'Espacio',
  'sale.lines.noText': 'Sin texto',
  'sale.lines.qtyUnit': '{qty} uds.',
  'sale.preview.receiptNoLabel': 'N.º de recibo:',
  'sale.preview.quoteNoLabel': 'N.º de presupuesto:',
  'sale.preview.orderNoLabel': 'N.º de pedido:',
  'sale.preview.backToOther': 'Volver a Otra venta',
  'sale.preview.backToInvoice': 'Volver a la factura',
  'sale.preview.vatMoms': 'IVA',
  'sale.preview.continuesNextPage': 'Continúa en la página siguiente',
  'sale.att.labelWithName': 'Adjunto · {name}',
  'sale.att.dropHere': 'Suelta el adjunto aquí',
  'sale.att.otherSaleHint': 'Otra venta sirve para ventas generales fuera del sistema: sube una imagen o un PDF como documentación.',
  'sale.att.previewHint': 'Para ver la vista previa, pulsa uno de tus adjuntos o «Ver recibo».',
  'sale.att.viewReceipt': 'Ver recibo',
  'sale.att.createReceipt': 'Crear recibo',
  'sale.mode.subtitle': 'Elige un flujo tranquilo paso a paso, o mantén todos los campos juntos en una sola página.',
  'sale.mode.stepsDesc': 'Cliente, detalles, líneas y vista previa, una cosa cada vez. Ideal para empezar.',
  'sale.mode.onePageDesc': 'Toda la factura junta con una vista previa en directo. Rápido cuando ya la conoces.',
  'sale.draft.noCustomer': 'Sin cliente',
  'sale.draft.noMatchesTitle': 'Sin resultados',
  'sale.draft.noMatchesText': 'Ningún borrador coincide con la búsqueda.',
  'sale.draft.emptyText': 'Las ventas que has empezado se guardan aquí cuando pulsas «Guardar borrador».',
  'sale.draft.colSale': 'Venta',
  'sale.draft.noNumber': 'Sin número',
  'sale.draft.colDate': 'Fecha',
  'sale.draft.colAmount': 'Importe',
  'sale.draft.deleteFailed': 'No se pudo eliminar el borrador.',
  'sale.draft.saveFailed': 'No se pudo guardar el borrador.',
  'sale.draft.deleteUnavailable': 'La eliminación de borradores no está conectada al backend.',
  'sale.draft.onlyDraftsDelete': 'Aquí solo se pueden eliminar borradores',
  'sale.draft.deleted': 'Borrador eliminado',
  'sale.draft.saveUnavailable': 'El guardado de borradores no está conectado al backend.',
  'sale.draft.savedToList': 'El borrador se ha guardado en la lista de facturas',
  'sale.create.invoice': 'Crear factura',
  'sale.create.quote': 'Crear presupuesto',
  'sale.create.order': 'Crear confirmación de pedido',
  'sale.create.other': 'Registrar venta',
  'sale.create.needMatchingPartials': 'La suma de los pagos parciales debe coincidir primero con el total de la venta',
  'sale.create.needLineOrAttachment': 'Añade primero una línea o un adjunto',
  'sale.create.needCustomerAndProduct': 'Elige primero un cliente y añade al menos un producto',
  'sale.create.needCustomer': 'Elige primero un cliente',
  'sale.create.needProduct': 'Añade primero al menos un producto',
  'sale.create.receiptSendingBackground': 'El recibo se está enviando en segundo plano',
  'sale.create.receiptSentEmail': 'El recibo se envió por correo electrónico.',
  'sale.create.recurringSaveFailed': 'La factura se creó, pero no se pudo guardar el contrato recurrente.',
  'sale.create.createFailed': 'No se pudo crear la venta.',
  'sale.create.createdTitle': 'Se ha creado {doc} {num}.',
  'sale.create.saleCreatedBody': 'La venta se ha contabilizado. Puedes guardar el recibo, enviar la documentación al cliente o cerrar.',
  'sale.create.docCreatedBody': 'Puedes guardar {def} como PDF o enviar {pron} por correo electrónico.',
  'sale.create.pdfReceiptLabel': 'PDF/Recibo',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'El envío no está disponible para esta venta.',
  'sale.send.unavailableDocument': 'El envío no está disponible para este documento.',
  'sale.send.failed': 'El envío ha fallado.',
  'sale.send.customerFallback': 'Cliente',
  'sale.send.defaultContactRole': 'Contacto predeterminado',
  'sale.send.contactFallback': 'Persona de contacto',
  'sale.send.recipientFallback': 'Destinatario',
  'sale.send.receiptTitle': 'Enviar recibo',
  'sale.send.howToSend': '¿Cómo quieres enviar {doc}?',
  'sale.send.receiptEmailHint': 'Introduce la dirección de correo a la que debe enviarse el recibo.',
  'sale.send.chooseDeliveryHint': 'Elige si el cliente recibe un PDF en el correo o un enlace que Postplumma puede rastrear.',
  'sale.send.allCustomersInList': 'Todos los clientes de la lista ({count})',
  'sale.send.needEmailFirst': 'Introduce un correo del cliente o de una persona de contacto antes de enviar.',
  'sale.send.stepDraftPrep': 'Preparando borrador',
  'sale.send.stepArriving': 'Postplumma está llegando',
  'sale.send.stepSuccess': '¡Listo! Postplumma va de camino.',
  'sale.send.receiptReadyNoEmail': 'El recibo está listo, pero no se envió ningún correo.',
  'sale.send.sendingInBackground': '{doc} se está enviando en segundo plano',
  'sale.send.sentAsLinkShort': '{doc} se envió como enlace.',
  'sale.send.sentAsLinkTracked': '{doc} se envió como enlace. Puedes seguir el estado de lectura en la lista de facturas.',
  'sale.send.sentAsEmail': '{doc} se envió por correo electrónico.',
  'sale.send.readyNoEmail': '{doc} está listo, pero no se envió ningún correo.',
  'sale.send.sentToRecipients': 'Enviado a {count} destinatarios.',
  'sale.send.notProvided': 'No indicado',
  'sale.send.spamTip': 'Consejo: si el cliente no encuentra el correo, pídele que revise la carpeta de spam o correo no deseado.',
  'sale.inboxPicker.tabInbox': 'Bandeja de entrada ({count})',
  'sale.inboxPicker.tabDocumentation': 'Documentación ({count})',
  'sale.inboxPicker.searchDocumentation': 'Buscar en la documentación',
  'sale.inboxPicker.searchInbox': 'Buscar en la bandeja de entrada',
  'sale.inboxPicker.selectTip': 'Consejo: mantén Shift para seleccionar varios seguidos, o Ctrl/Cmd para seleccionarlos uno a uno.',
  'sale.inboxPicker.emptyDocumentation': 'Ningún documento coincide con la búsqueda.',
  'sale.inboxPicker.emptyInbox': 'Ningún justificante de la bandeja de entrada coincide con la búsqueda.',
  'sale.inboxPicker.fallbackReceipt': 'Justificante',
  'sale.inboxPicker.fallbackDocument': 'Documento',
  'sale.inboxPicker.fallbackDocumentation': 'Documentación',
  'sale.lines.subscriptionPeriod': 'Suscripción - {{period}}',
  'sale.lines.months12': '12 meses',
  'sale.lines.month1': '1 mes',
  'sale.lines.rentalPrice': 'Alquiler - {{price}}',
  'sale.lines.addAsNewProduct': 'Añadir «{{value}}» como nuevo producto',
  'sale.lines.useDivider': 'Usar línea separadora',
  'sale.lines.dividerHint': 'Muestra una línea bajo esta fila en el documento.',
  'sale.preview.colDescription': 'Descripción',
  'sale.preview.colQty': 'Cant.',
  'sale.preview.colPrice': 'Precio',
  'sale.preview.colDiscount': 'Descuento',
  'sale.preview.colSum': 'Total',
  'sale.doc.invoiceName': 'Factura',
  'sale.doc.quoteName': 'Presupuesto',
  'sale.doc.orderConfirmationName': 'Confirmación de pedido',
  'sale.doc.creditNoteName': 'Nota de crédito',
  'sale.draft.colType': 'Tipo',
  'sale.period.every14days': 'Cada 14 días',
  'sale.det.dueDays': '{{count}} días',
  'sale.lines.priceExVat': 'Precio sin IVA',
  'sale.lines.priceIncVat': 'Precio con IVA',
  'sale.lines.lineNumber': 'Línea {{n}}',
  'sale.lines.pickProduct': 'Elegir producto',
  'sale.lines.freeText': 'Texto libre',
  'sale.lines.spacerHint': 'Una línea vacía aparece como un espacio en blanco en el documento.',
  'sale.lines.chooseLineType': 'Elegir tipo de línea',
  'agreements.notSent': 'No enviada',
  'agreements.error.missingCustomerEmail': 'El cliente no tiene dirección de correo. Añade un correo al cliente y la factura se enviará en la próxima ejecución.',
  'agreements.error.missingCustomer': 'El cliente ya no existe o está archivado. Elige un cliente activo para el contrato.',
  'agreements.warning.missingCustomerEmail': 'El cliente no tiene dirección de correo',
  'agreements.warning.missingCustomerEmailHelp': 'El envío automático necesita una dirección de correo. Añádela al cliente antes de la próxima fecha de factura, o la factura no se enviará.',
});
